// Dependencies
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
 
// Components
import ProductAreaAppDev from './demo/dev'; 
import ProductAreaAppStage from './demo/stage'; 
import ProductAreaApp from './containers/App';

// Utils
import { REACT_APP_ENV, REACT_APP_ROOT } from './utils/config';

const appMap: any = {
    development: ProductAreaAppDev,
    staging: ProductAreaAppStage,
    production: ProductAreaApp
}

const App = REACT_APP_ENV in appMap ? appMap[REACT_APP_ENV] : appMap.production;

ReactDOM.render( 
    <React.StrictMode>
        <App />
    </React.StrictMode>, 
REACT_APP_ROOT);  